import {CommonModule} from '@angular/common';
import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-favorite-alert-consent-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './favorite-alert-consent-modal.component.html',
  styleUrl: './favorite-alert-consent-modal.component.css'
})
export class FavoriteAlertConsentModalComponent {
  @Input() isSaving = false;
  @Input() errorMessage = '';
  @Output() accepted = new EventEmitter<void>();
  @Output() declined = new EventEmitter<void>();
}
